export default class CalculationsDetailed {
  competenceMonth: string;

  competenceYear: string;

  ruleName: string;

  value: string;

  discountedValue: number;

  createdDate: string;

  summary: any[];

  feedValue: number;

  itemNumber: number;

  constructor(obj: any) {
    this.competenceMonth = obj.competenceMonth || '';
    this.competenceYear = obj.competenceYear || '';
    this.ruleName = obj.ruleName || '';
    this.value = obj.value || '';
    this.discountedValue = obj.discountedValue || null;
    this.feedValue = obj.feedValue || null;
    this.createdDate = obj.created_date || '';
    this.summary = obj.summary || '';
    this.itemNumber = obj.itemNumber || null;
  }

  public static of(obj: any = {}): CalculationsDetailed {
    return new CalculationsDetailed(obj);
  }

  public static ofList(obj: any[]): CalculationsDetailed[] {
    return obj.map(this.of)
  }
}
